import CovidDriving from '@root/joinroot.com/src/components/covid-driving';
import HeroImageTop from '@root/gatsby-contentful-core/src/components/sections/hero-section/hero-section_image-top';
import IconTout from '@root/gatsby-contentful-core/src/components/sections/icon-tout/icon-tout';
import IconToutSection from '@root/gatsby-contentful-core/src/components/sections/icon-tout/icon-tout-section';
import LinkButton from '@root/gatsby-contentful-core/src/components/buttons/link-button';
import LinkButtonModel from '@root/gatsby-contentful-core/src/models/link-button';
import PageTemplate from '@root/joinroot.com/src/components/pages/page-template';
import PropTypes from '@root/vendor/prop-types';
import React from '@root/vendor/react';
import RootAppIcon from '@root/joinroot.com/src/assets/images/root-app-icon.png';
import { BRAND_BLING_OPTIONS } from '@root/gatsby-contentful-core/src/components/brand-bling';
import { graphql } from 'gatsby';

export default function CovidDrivingPage({ data, location }) {
  const button = () => (
    <LinkButton
      id={'covid-19-response-button'}
      to={'/covid-19-response'}
      type={LinkButtonModel.types.PRIMARY}
    >
      COVID resources
    </LinkButton>
  );

  return (
    <PageTemplate
      analyticsContext={'COVID_DRIVING_PAGE'}
      location={location}
      pageCanonical={'https://www.joinroot.com/covid-driving/'}
      pageDescription={'Root explores the latest driving data to assess the impact of COVID on driving behavior.'}
      pageTitle={'Driving trends during COVID | Root Insurance Company'}
    >
      <HeroImageTop
        body={'Sometimes the best driving is less driving—or not driving at all. As the COVID crisis has developed, Root customers have done their part to flatten the curve by trading their daily commutes for the safety of their homes. In this report, we explore our latest data to assess the impact of COVID on driving behavior.'}
        brandBlingOptions={BRAND_BLING_OPTIONS.NONE}
        gatsbyImage={data.file.childImageSharp.fluid}
        headline={'Driving down the curve'}
      />

      <CovidDriving />
      <IconToutSection >
        <IconTout
          body={'At Root, we’re committed to responding to the needs of our customers as the COVID crisis evolves.'}
          button={button}
          icon={RootAppIcon}
          iconAlt={'Orange Root icon'}
          id={'covid-driving-icon-tout'}
          title={'Understanding insurance options during COVID'}
        />
      </IconToutSection>
    </PageTemplate>
  );
}

CovidDrivingPage.propTypes = {
  data: PropTypes.shape({
    file: PropTypes.shape({
      childImageSharp: PropTypes.shape({
        fluid: PropTypes.object,
      }),
    }).isRequired,
  }),
  location: PropTypes.shape({
    search: PropTypes.string.isRequired,
    pathname: PropTypes.string.isRequired,
  }.isRequired),
};

export const data = graphql`
    query {
      file(relativePath: { eq: "covid-driving/header.jpg" }) {
        childImageSharp {
          fluid(quality: 100, maxWidth: 1920) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `;
